import { SourceCard, type SourceCardProps } from '../SourceCard'

type InternalSourceCardProps = Omit<SourceCardProps, 'ctaIcon'>

const InternalSourceCard = ({ ...props }: InternalSourceCardProps) => {
  return <SourceCard {...props} ctaIcon={['far', 'chevron-right']} />
}

export { InternalSourceCard }
